export const ARTICLE_SEND_REQUEST = 'ARTICLE_SEND_REQUEST';
export const ARTICLE_RECEIVE_RESPONSE = 'ARTICLE_RECEIVE_RESPONSE';
